<template>
  <div class="root">
    <div class="header-box" :class="addBackground">
      <div class="c-header" :class="headerClass">
        <div class="header-logo">
          <a href="/">
            <img v-if="addBackground === ''" src="./images/header-logo-white-xd.png">
            <img v-else src="./images/header-logo-orange-xd.png">
          </a>
        </div>
        <!-- <div class="credit">
        <a href="javascript:;" @click.prevent="showQrcode">征信查询</a>
        <div class="qrcode-box">
          <i class="close-btn" @click="closeQrcode"></i>
          <div class="qrcode-content">
            <p>风险信用不可小觑</p>
            <p>您有一份征信报告待查看</p>
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
            <div class="foot">扫码即刻查征信</div>
          </div>
        </div>
      </div> -->
        <ul class="nav">
          <li v-for="(item,index) in navList" :key="index">
            <a @click="goUrl(item.url)" :class="{ active:index==currentPage}">{{item.name}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="notice-bg">
      <div class="new-notice" v-if="!lastNotice.isImage">
        <h2>{{lastNotice.title}}</h2>
        <p class="update-time">{{lastNotice.releaseDate}}(发布时间)</p>
        <div style="padding-bottom:50px;" v-html="lastNotice.content"></div>
        <span class="more-notice" @click="goNoticeList">更多公告>></span>
      </div>
      <div class="new-notice" v-else>
        <div style="padding-bottom:50px;">
          <img style="width:100%;" :src="require(`./images/${lastNotice.content}`)" alt="图片加载失败">
        </div>
        <span class="more-notice" @click="goNoticeList">更多公告>></span>
      </div>
      <span class="blue-shadow"></span>
    </div>
  </div>
</template>

<script>
import notice from "@/global/js/staticData/notice";
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  name: "announcement",
  data() {
    return {
      navList: [
        {
          name: "联系我们",
          url: "/contactUs",
        },
        {
          name: "加入我们",
          url: "/joinUsMain",
        },
        {
          name: "公司公告",
          url: "/announcementList",
        },
        {
          name: "场景服务",
          url: "/sceneService",
        },
        {
          name: "关于八戒小贷",
          url: "/aboutUs",
        },
        {
          name: "首页",
          url: "/index",
        },
      ],
      currentPage: 2,
      headerClass: "",
      addBackground: "",
      lastNotice: {},
      noticeName: "",
      releaseDate: "",
    };
  },
  mounted() {
    this.$bus.$emit("ready");
    window.addEventListener("scroll", this.getScroll);
    this.noticeName = this.$route.query.name || "";
    this.releaseDate = this.$route.query.releaseDate || "";
    if (!this.noticeName) {
      this.lastNotice = notice.noticeList[0] || {};
    } else {
      notice.noticeList.map((item) => {
        if (item.title === this.noticeName && item.releaseDate === this.releaseDate) {
          this.lastNotice = item;
        }
      });
    }
  },
  methods: {
    goUrl(url) {
      this.$router.push(url);
    },
    // 监听滚动 改变悬浮头部的样式
    getScroll() {
      let scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      if (scrollTop > 0) {
        // 这个值每个页面可能都不一样，需要独立计算
        this.headerClass = "white-header";
        this.addBackground = "add-bg";
      } else {
        this.headerClass = "";
        this.addBackground = "";
      }
    },
    goNoticeList() {
      this.$router.push({
        path: "/announcementList",
      });
    },
    showQrcode() {
      $(".qrcode").html("");
      let qrcode = new QRCode("qrcode", {
        width: 154, // 设置宽度
        height: 154, // 设置高度
        text: "https://m.tianxiaxinyong.cn/cooperation/crp-v2/per-detail.html?channel=K3lRa1Z6WE9aY2Iveng0VHNoN2d3Zz09",
      });
      $(".qrcode-box").slideDown(300, "linear", function () {
        $(".qrcode-content").fadeIn(500);
      });
    },
    closeQrcode() {
      $(".qrcode-box").fadeOut();
      $(".qrcode-content").hide();
    },
  },
};
</script>

<style scoped rel="stylesheet/less" lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
.header-box {
  width: 100%;
  height: 104px;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
  &.add-bg {
    background: url("./images/white-header-bg.png") no-repeat top center;
  }
}
.c-header {
  font-size: 22px;
  width: 1200px;
  height: 80px;
  line-height: 80px;
  // overflow: hidden;
  position: fixed;
  top: 0;
  left: 50%;
  margin-left: -600px;
  z-index: 999;
  background-color: transparent;
  .header-logo {
    float: left;
    width: 105px;
    height: 80px;
    text-align: center;
    position: relative;
    img {
      width: 166px;
      vertical-align: middle;
      // position: relative;
      // bottom: 3px;
    }
  }
  .credit {
    float: right;
    width: 124px;
    height: 80px;
    text-align: center;
    position: relative;
    margin-left: 55px;
    font-size: 16px;
    a {
      position: absolute;
      width: 124px;
      height: 40px;
      line-height: 40px;
      left: 0;
      top: 20px;
      color: #fff;
      background: url("./images/credit.png") no-repeat;
    }
    .qrcode-box {
      display: none;
      position: absolute;
      width: 264px;
      height: 447px;
      top: 60px;
      left: -70px;
      box-sizing: border-box;
      padding: 137px 36px 26px 36px;
      background: url("./images/qrcode-box.png") no-repeat;
      .close-btn {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 145px;
        right: 40px;
        background: url("./images/qrcode-close.png") no-repeat;
        cursor: pointer;
      }
      .qrcode-content {
        width: 160px;
        height: 260px;
        padding: 24px 16px 0px 16px;
        display: none;
        p {
          height: 20px;
          line-height: 20px;
          color: #000000;
          font-size: 12px;
        }
        .qrcode {
          width: 154px;
          height: 154px;
          padding: 4px;
          border: 2px solid #ffc39c;
          margin-top: 5px;
        }
        .foot {
          width: 155px;
          height: 38px;
          margin: 0 auto;
          line-height: 38px;
          text-align: center;
          background: url("./images/qrcode-line.png") no-repeat center;
          color: #000000;
          font-size: 12px;
        }
      }
    }
  }
  .nav {
    li {
      float: right;
      cursor: pointer;
      margin-left: 55px;
      height: 80px;
      a {
        color: #fefefe;
        font-size: 16px;
        padding: 5px 0;
        &:hover {
          color: #ffffff;
          border-bottom: 2px solid #ffffff;
        }
        &.active {
          color: #ffffff;
          border-bottom: 2px solid #ffffff;
        }
      }
    }
  }
  &.white-header {
    .nav {
      li {
        float: right;
        cursor: pointer;
        margin-left: 55px;
        height: 80px;
        a {
          color: #464440;
          font-size: 16px;
          padding: 5px 0;
          &:hover {
            color: #12151f;
            border-bottom: 2px solid #ff3600;
          }
          &.active {
            color: #12151f;
            border-bottom: 2px solid #ff3600;
          }
        }
      }
    }
  }
}
.notice-bg {
  width: 100%;
  min-height: 940px;
  background-image: url("./images/company-notice-bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-color: #f9fafa;
  position: relative;
  box-sizing: border-box;
  padding-top: 350px;
  padding-bottom: 60px;
  .new-notice {
    width: 1200px;
    min-height: 530px;
    margin: 0 auto;
    padding: 44px 44px 60px 40px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 5px 5px #eeeeee;
    box-sizing: border-box;
    position: relative;
    z-index: 11;
    h2 {
      font-size: 28px;
      color: #333333;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: url("./images/icon-affirming.png") no-repeat bottom center;
      font-weight: bold;
    }
    .more-notice {
      position: absolute;
      left: 40px;
      cursor: pointer;
      color: #fc6500;
      font-size: 16px;
      bottom: 40px;
    }
    .update-time {
      color: #999999;
      font-size: 14px;
      text-align: right;
      height: 30px;
      line-height: 30px;
      padding-bottom: 40px;
    }
    .text {
      color: #44444c;
      font-size: 14px;
      line-height: 30px;
      span {
        color: #222222;
      }
    }
  }
  .blue-shadow {
    position: absolute;
    width: 17px;
    height: 224px;
    background: url("./images/notice-shadow.png") no-repeat;
    right: 50%;
    margin-right: -610px;
    top: 351px;
    z-index: 10;
  }
}
</style>



// WEBPACK FOOTER //
// announcement.vue?40dfaed2